import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

const ThemeProvider = ({ theme, children }) => <StyledThemeProvider theme={theme}>{children}</StyledThemeProvider>;

export default ThemeProvider;
